// extracted by mini-css-extract-plugin
export var checkboxInputRow = "y_tX";
export var checkboxInputColumn = "y_tY";
export var inputOptionRow = "y_qT";
export var inputOptionColumn = "y_qV";